export class UtilisateurFamille {
    adresseMail?: string;
    cguAcceptees?: boolean;
    afficheMessageAccueil?: boolean;
    numeroTelephone?: string;
    idIndicatifTel?: number;
    longueurNumero?: number;

    constructor(adresseMail?: string, cguAcceptees?: boolean, afficheMessageAccueil?: boolean, numeroTelephone?: string) {
        this.adresseMail = adresseMail;
        this.cguAcceptees = cguAcceptees;
        this.afficheMessageAccueil = afficheMessageAccueil;
        this.numeroTelephone = numeroTelephone;
    }
}
